"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModelSchema = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Clase base (heredable) para crear instancias de esquemas que representan "tablas de base de datos".
 * Nos da la flexibilidad de crear reglas de negocio tanto para insertar o modificar informacion en las tablas que deseamos representar. 
 * 
 * @class
 * @author Camilo Bello [<camilo.bello@crecic.cl>]
 */
var ModelSchema = /*#__PURE__*/function () {
  /**
   * Metodo constructor encargado de crear un nuevo esquema dependiendo del medio donde sea llamado
   * @constructs ModelSchema
   * @param {Object} schema Definicion del esquema
   */
  function ModelSchema(schema) {
    (0, _classCallCheck2["default"])(this, ModelSchema);
    this.schemaModel = schema; // Set de data types

    this.dataTypes = [{
      "name": "string",
      "showMessage": "texto"
    }, {
      "name": "boolean",
      "showMessage": "verdadero o falso"
    }, {
      "name": "number",
      "showMessage": "númerico"
    }, {
      "name": "object",
      "showMessage": "objeto"
    }, {
      "name": "function",
      "showMessage": "función"
    }]; // Alamecenes para errores

    this.errors = [];
    this.dataErrors = {};
  }

  (0, _createClass2["default"])(ModelSchema, [{
    key: "useDefaultValue",
    value: function useDefaultValue(property, element) {
      if (!property && this.schemaModel[element].hasOwnProperty('required') && this.schemaModel[element].required === false && this.schemaModel[element].hasOwnProperty('defaultValue')) {
        return true;
      }

      return false;
    }
  }, {
    key: "isValidDataType",
    value: function isValidDataType(property, body) {
      if (property && body && (0, _typeof2["default"])(body[property]) !== this.schemaModel[property].type || property && this.schemaModel[property].type === 'number' && typeof body[property] === "number" && body[property].toString() === "NaN") {
        return false;
      }

      return true;
    }
  }, {
    key: "setMessageTypeData",
    value: function setMessageTypeData(dataType) {
      var _this$dataTypes$find;

      return ((_this$dataTypes$find = this.dataTypes.find(function (type) {
        return type.name === dataType;
      })) === null || _this$dataTypes$find === void 0 ? void 0 : _this$dataTypes$find.showMessage) || '';
    }
  }, {
    key: "setErrorsFound",
    value: function setErrorsFound(property, newError) {
      this.errors = [].concat((0, _toConsumableArray2["default"])(this.errors), [newError]);
      this.dataErrors[property] = [].concat((0, _toConsumableArray2["default"])(this.dataErrors[property]), [newError]);
    }
    /**
     * Metodo encargado de validar el objeto que deseamos guardar en base de datos en base al esquema definido, comprobando si las reglas
     * de negocio se cumplen en lo definido en el esquema
     * @param {Object} body Objeto que sera utilizado para ser validado con el esquema definido
     * @param {Boolean} particularFields Indica si queremos analizar todos los campos según lo definido en el model. Por defecto su valor es "false"
     * @return {Object} Retorna un objeto con el body del request (peticion HTTP) validado y ordenado por sus propiedades (segun esquema)
     */

  }, {
    key: "isValidSchema",
    value: function () {
      var _isValidSchema = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(body) {
        var _this = this;

        var particularFields,
            keysBodyEntry,
            keysSchema,
            orderBody,
            _iterator,
            _step,
            _loop,
            keysErrorsDataWithArrayEmpty,
            _args = arguments;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                particularFields = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                keysBodyEntry = Object.keys(body);
                keysSchema = Object.keys(this.schemaModel); // SE VALIDA QUE NO EXISTAN PROPIEDADES CON VALORES UNDEFINED

                if (keysBodyEntry.some(function (key) {
                  return body.hasOwnProperty(key) && body[key] === undefined;
                })) {
                  this.errors = [].concat((0, _toConsumableArray2["default"])(this.errors), ["No se permiten valores indefinidos"]);
                } // FILTRAMOS SÓLO LAS PROPIEDADES DEL ESQUEMA SEGÚN EL BODY QUE ESTAMOS RECIBIENDO


                if (particularFields === true) {
                  keysSchema = keysSchema.filter(function (x) {
                    return keysBodyEntry.find(function (y) {
                      return y === x;
                    });
                  });
                }

                orderBody = {};
                _iterator = _createForOfIteratorHelper(keysSchema);

                try {
                  _loop = function _loop() {
                    var keyName = _step.value;
                    var propertySchema = keyName;

                    if (!_this.dataErrors.hasOwnProperty(propertySchema)) {
                      _this.dataErrors[propertySchema] = [];
                    }

                    var findKey = keysBodyEntry.find(function (x) {
                      return x === propertySchema;
                    });

                    if (findKey && typeof body[propertySchema] === 'string') {
                      body[propertySchema] = body[propertySchema].trim();
                    }

                    if (_this.useDefaultValue(findKey, propertySchema)) {
                      body[propertySchema] = _this.schemaModel[propertySchema].defaultValue;
                    }

                    var dataTypeIsValid = !_this.isValidDataType(findKey, body) ? "".concat(_this.schemaModel[propertySchema].alias, " debe ser de tipo ").concat(_this.setMessageTypeData(_this.schemaModel[propertySchema].type)) : null;

                    if (_this.schemaModel[propertySchema].hasOwnProperty('type') && body[propertySchema] !== null && dataTypeIsValid) {
                      _this.setErrorsFound(propertySchema, dataTypeIsValid);
                    }

                    if (!findKey && _this.schemaModel[propertySchema].required && !particularFields || findKey && typeof body[propertySchema] === 'string' && _this.schemaModel[propertySchema].required && body[propertySchema].length === 0 || findKey && _this.schemaModel[propertySchema].required && body[propertySchema] === null) {
                      var stringRequired = "".concat(_this.schemaModel[propertySchema].alias, " es requerido");

                      _this.setErrorsFound(propertySchema, stringRequired);
                    }

                    if (findKey && typeof body[propertySchema] === 'string' && _this.schemaModel[propertySchema].hasOwnProperty('maxLength') && body[propertySchema].length > _this.schemaModel[propertySchema].maxLength) {
                      var maxCharactersString = "".concat(_this.schemaModel[propertySchema].alias, " puede contener hasta ").concat(_this.schemaModel[propertySchema].maxLength, " caracteres");

                      _this.setErrorsFound(propertySchema, maxCharactersString);
                    }

                    if (findKey && _this.schemaModel[propertySchema].hasOwnProperty('validate') && typeof _this.schemaModel[propertySchema].validate === "function" && body[propertySchema] !== null) {
                      var validate = _this.schemaModel[propertySchema].validate(body[propertySchema]);

                      if (validate.hasOwnProperty('ok') && validate.ok === false) {
                        var message = "".concat(_this.schemaModel[propertySchema].alias, ": ").concat(validate === null || validate === void 0 ? void 0 : validate.message);

                        _this.setErrorsFound(propertySchema, message);
                      } else {
                        if (validate[propertySchema]) {
                          body[propertySchema] = validate[propertySchema];
                        }
                      }
                    }

                    _this.errors = (0, _toConsumableArray2["default"])(new Set(_this.errors.map(function (e) {
                      return e;
                    })));
                    _this.dataErrors[propertySchema] = (0, _toConsumableArray2["default"])(new Set(_this.dataErrors[propertySchema].map(function (e) {
                      return e;
                    })));

                    if (!_this.schemaModel[propertySchema].hasOwnProperty('notIncluded') && body[propertySchema] !== undefined) {
                      orderBody = _objectSpread(_objectSpread({}, orderBody), {}, (0, _defineProperty2["default"])({}, propertySchema, body[propertySchema]));
                    }
                  };

                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                keysErrorsDataWithArrayEmpty = Object.keys(this.dataErrors).filter(function (key) {
                  return _this.dataErrors[key] && _this.dataErrors[key].length === 0;
                });
                keysErrorsDataWithArrayEmpty.forEach(function (key) {
                  if (_this.dataErrors.hasOwnProperty(key)) {
                    delete _this.dataErrors[key];
                  }
                });

                if (!(this.errors.length > 0)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", {
                  ok: false,
                  dataErrors: this.dataErrors,
                  messages: this.errors
                });

              case 12:
                return _context.abrupt("return", {
                  ok: true,
                  body: orderBody
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function isValidSchema(_x) {
        return _isValidSchema.apply(this, arguments);
      }

      return isValidSchema;
    }()
  }, {
    key: "equalsObjects",
    value: function equalsObjects(objBD, bodyToUpdate) {
      var differences = [];

      if (objBD && bodyToUpdate) {
        var aKeys = Object.keys(objBD).sort();
        var bKeys = Object.keys(bodyToUpdate).sort();

        for (var i = 0; i < aKeys.length; i++) {
          var messageCustom = bodyToUpdate[bKeys[i]];

          if (this.schemaModel.hasOwnProperty(aKeys[i]) && this.schemaModel[aKeys[i]] && this.schemaModel[aKeys[i]].hasOwnProperty('messageCustom')) {
            messageCustom = this.schemaModel[aKeys[i]]['messageCustom'](bodyToUpdate[bKeys[i]]);
          }

          if (Array.isArray(bodyToUpdate[aKeys[i]]) && Array.isArray(objBD[aKeys[i]]) && bodyToUpdate[aKeys[i]].length !== objBD[aKeys[i]].length) {
            differences.push("".concat(this.schemaModel.hasOwnProperty(aKeys[i]) && this.schemaModel[aKeys[i]] ? this.schemaModel[aKeys[i]].alias : aKeys[i], ": ").concat(messageCustom));
          }

          if ((0, _typeof2["default"])(bodyToUpdate[aKeys[i]]) === 'object' && bodyToUpdate[aKeys[i]] && Object.keys(bodyToUpdate[aKeys[i]]).length > 0) {
            var difObj = this.equalsObjects(objBD[aKeys[i]], bodyToUpdate[aKeys[i]]);

            if (difObj && difObj.length > 0) {
              differences = [].concat((0, _toConsumableArray2["default"])(differences), ["".concat(this.schemaModel.hasOwnProperty(aKeys[i]) && this.schemaModel[aKeys[i]] ? this.schemaModel[aKeys[i]].alias : aKeys[i], ": ").concat(messageCustom)]);
            }
          } else {
            if (objBD.hasOwnProperty(aKeys[i]) && bodyToUpdate.hasOwnProperty(aKeys[i]) && objBD[aKeys[i]] !== bodyToUpdate[aKeys[i]]) {
              differences.push("".concat(this.schemaModel.hasOwnProperty(aKeys[i]) && this.schemaModel[aKeys[i]] ? this.schemaModel[aKeys[i]].alias : aKeys[i], ": ").concat(messageCustom));
            }
          }
        }
      }

      return (0, _toConsumableArray2["default"])(new Set(differences.map(function (diff) {
        return diff;
      })));
    }
    /**
     * Metodo encargado de preparar queries para modificación de datos ayudándose del esquema del modelo definido realizando un match del nombre del 
     * campo virtual con el nombre del campo físico en base de datos
     * @param {Object} body Objeto utilizado para realizar el match entre lo definido en el modelo y la información que se modificará (body)
     * @param {Object} whereClausule Objeto que contiene el where y el operador de compración
     * @param {Object} whereClausule.where Objeto where que contiene la condición que se establecerá al momento de construir la query de modificación de datos
     * @param {String} whereClausule.operator Operador de comparación para cláusula where, por defecto su valor es "="
     * @return {Object} Retorna un objeto con el "setFields" en formato string y "whereFields" en formato string
     * @example <caption>Creación de update dinámico</caption>
     * // En nuestro respository.js
     * // Ejemplo de "criteria"
     * const criteria = { "where": { "roleId": 1 } };
     * async updateByCriteria (connection, criteria, body) {
     *      // Instanciamos nuestro model que contiene las definciones de campos virtuales y físicos de base datos
     *      const roleModel = new RoleModel();
     *      // query base
     *      let query = "UPDATE rol SET";
     * 
     *      // Invocamos el méotodo para realizar la creación de los campos a setear y la cláusula where
     *      let { setFields, whereFields } = roleModel.prepareQueryUpdate(body, criteria);
     * 
     *      // Validamos que el body no esté vacío, si no está vacío se procede a la concatenación de la query
     *      if (Object.keys(body).length > 0) {
     *          // Concatenamos la query base con lo retonardo por la función
     *          query = `
     *              ${query}
     *              ${setFields}
     *              ${whereFields}
     *          ` ;
     *      }
     * } 
     */

  }, {
    key: "prepareQueryUpdate",
    value: function prepareQueryUpdate(body, _ref) {
      var _this2 = this;

      var where = _ref.where,
          _ref$operator = _ref.operator,
          operator = _ref$operator === void 0 ? "=" : _ref$operator;
      var keysWhere = Object.keys(where);
      var keysBodyEntry = Object.keys(body);
      var keysSchema = Object.keys(this.schemaModel);
      var setFields = '';
      var whereFields = ' WHERE ';
      var param = keysWhere.length + 1;

      var _loop2 = function _loop2(index) {
        var element = keysWhere[index];
        var findKey = keysSchema.find(function (x) {
          return x === element;
        });

        if (findKey) {
          whereFields += " ".concat(_this2.schemaModel[findKey]['nameFieldDatabase'], " ").concat(operator, " $").concat(index + 1);
        }

        if (index < keysWhere.length - 1) whereFields += ' AND ';
      };

      for (var index = 0; index < keysWhere.length; index++) {
        _loop2(index);
      }

      var _loop3 = function _loop3(_index) {
        var element = keysBodyEntry[_index];
        var findKey = keysSchema.find(function (x) {
          return x === element;
        });

        if (findKey) {
          setFields += " ".concat(_this2.schemaModel[findKey]['nameFieldDatabase'], " = $").concat(param);
          param++;
          if (_index < keysBodyEntry.length - 1) setFields += ', ';
        }
      };

      for (var _index = 0; _index < keysBodyEntry.length; _index++) {
        _loop3(_index);
      }

      whereFields += " RETURNING *";
      return {
        setFields: setFields,
        whereFields: whereFields
      };
    }
  }, {
    key: "getAllKeysModelSchema",
    value: function getAllKeysModelSchema() {
      var keysSchema = Object.keys(this.schemaModel);
      return keysSchema;
    }
  }]);
  return ModelSchema;
}();

exports.ModelSchema = ModelSchema;